import { useEffect } from "react";

import mixpanel from "mixpanel-browser";

let initialized = false;
const MIXPANEL_API = window && window.location && window.location.hostname;
if (!initialized) {
  mixpanel.init(
    import.meta.env.MODE !== "development"
      ? import.meta.env.VITE_APP_MIXPANEL_TOKEN
      : "sd",
    {
      api_host: MIXPANEL_API
        ? `https://${MIXPANEL_API}/mixpanel`
        : "https://api-eu.mixpanel.com",
      debug: false,
      track_pageview: false,
      persistence: "localStorage",
    }
  );
  initialized = true;
}

export { mixpanel };
